import { AxiosResponse } from 'axios'
import { IFilter, UpdateBody } from 'types/common'
import { AggregationPipeline } from 'types/common/aggregation'
import { api } from 'API'
import { AggregationPaginated } from 'interfaces/common'
import { IProcess, IProcessWithRelations } from 'interfaces/process'
import { IStep, IStepWithRelations } from 'interfaces/step'

export async function createStep(step: UpdateBody<IStep>): Promise<void> {
  await api.post('/steps', step)
}

export async function createStepFromCommonStep(step: UpdateBody<IStep>): Promise<void> {
  await api.post('/steps/from-common-step', step)
}

export async function updateStepById(id: number, updateBody: UpdateBody<IStep>): Promise<void> {
  await api.patch(`/steps/${id}`, updateBody)
}

export async function updateDerivedStep(id?: number, commonStepId?: number): Promise<void> {
  if (!id && !commonStepId) return
  await api.patch(`/steps/${id}/to-common-step/${commonStepId}`)
}

export async function updateStepBatch(updateBody: UpdateBody<IStep[]>): Promise<void> {
  await api.patch(`/steps/position/batch`, updateBody)
}

export async function deleteStepById(id: number): Promise<void> {
  await api.delete(`/steps/${id}`)
}

export async function getSteps(filter: IFilter<IStepWithRelations>): Promise<IStepWithRelations[]> {
  const response = await api.get(`/steps?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function getStepDetail(id: number, filter: IFilter<IStepWithRelations>): Promise<IStepWithRelations> {
  const response = await api.get(`/steps/${id}?filter=${JSON.stringify(filter)}`)
  return response.data
}

export async function getDependentProcessesOnCommonStep(id: number): Promise<IProcessWithRelations[]> {
  const response = await api.get(`/steps/${id}/dependent-processes`)
  return response.data ?? []
}

export async function getDependentProcessesForFilter(): Promise<IProcessWithRelations[]> {
  const response = await api.get(`/dependent-processes`)
  return response.data ?? []
}

export async function getStepsByAggregate(pipeline: AggregationPipeline): Promise<IStep[]> {
  try {
    const response: AxiosResponse = await api.post(`/steps/aggregate`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function getStepsFromGroupByAggregate(pipeline: AggregationPipeline): Promise<IStepWithRelations[]> {
  try {
    const response: AxiosResponse = await api.post(`/group-members/aggregate`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function aggregateGroupMember(pipeline: AggregationPipeline): Promise<IStep[]> {
  try {
    const response: AxiosResponse = await api.post(`/group-members/aggregate`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}

export async function aggregateGroupMemberSearch(
  pipeline: AggregationPipeline
): Promise<AggregationPaginated<IProcess>> {
  try {
    const response: AxiosResponse = await api.post(`/group-members/aggregate/search`, {
      pipeline
    })
    return response?.data
  } catch (error: any) {
    return { paginatedResults: [], totalResults: 0 }
  }
}

export async function aggregateCountGroupMember(pipeline: AggregationPipeline = []): Promise<number> {
  const response: AxiosResponse = await api.post(`/group-members/aggregate/count`, {
    pipeline
  })
  return response?.data[0]?.totalResults ?? 0
}
